import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const customReportingTableHeadings = [];

const customReportingTableData = function () {
	var tableData = [];

	return tableData;
};

export {
	customReportingTableHeadings,
	customReportingTableData
};
